import { HttpService } from './http';
import { ApiResponse, Areas, Point } from '../models';

/**
 * General Service
 */

class GeneralService {
  public constructor(private readonly http: HttpService) {}
}

export { GeneralService };
